import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';

import getAccountCardQuery from '../../../../services/cards/graphql/queries/getAccountCard';
import AccountCard from '../../../../services/cards/components/AccountCard';

const propTypes = {
  accountCard: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  cardSide: PropTypes.string,
};

const AccountCardPrint = ({ accountCard, cardSide }) => {
  if (!accountCard) {
    return null;
  }

  return (
    <Fragment>
      <Helmet>
        <body className="body-account-card-print" />
      </Helmet>

      <AccountCard
        printable
        accountCard={accountCard}
        defaultSide={cardSide}
        animatable={!!cardSide}
        onElementConfigurationChange={() => {}}
      />
    </Fragment>
  );
};

AccountCardPrint.propTypes = propTypes;

const withAccountCard = graphql(getAccountCardQuery, {
  options: ({ match }) => ({
    variables: {
      id: match?.params?.accountCardId,
    },
  }),
  props: ({ data: { accountCard } = {}, ownProps }) => {
    const { match } = ownProps;
    const cardSide = (match?.params?.side ?? '').toUpperCase();

    return {
      cardSide,
      accountCard,
    };
  },
});

export default compose(withRouter, withAccountCard)(AccountCardPrint);
